import { Action, any, fromJSX, stateful } from "widgets-for-react";
import { SearchModalLayout } from "./searchModalLayout";
import { initialState, SearchModalProps, SearchModalState } from "./searchModalState";

export const SearchModalWidget = (props: SearchModalProps) => {
  return stateful<SearchModalState>({ key: 'recent_news_block' })(s0 =>
    any<Action<SearchModalState>>()([
      fromJSX((setState) => SearchModalLayout({
        ...s0,
        ...props,
        updateQuery: (searchQuery) => setState(s0 => ({ ...s0, searchQuery })),
        runSearch: () => {
          props.runNewQuery(s0.searchQuery)
          setState(_ => ({...initialState}))
        }
      }))
    ]).map(a => a(s0))
  )(initialState)
}
